export default {
  message: {
    "strid1": "လော့ဂ်အင်",
    "strid2": "ကြေငြာချက်",
    "strid3": "နောက်ထပ်",
    "strid4": "ပြစ်ဒဏ်စုံစမ်းရေး",
    "strid5": "စုံစမ်းရေးအစီရင်ခံစာ",
    "strid6": "ပြစ်ဒဏ်ကြေငြာချက်",
    "strid7": "လုံခြုံရေးသိပ္ပံ",
    "strid8": "ပြစ်ဒဏ်စည်းမျဉ်းများ",
    "strid9": "အချိန်အစီရင်ခံပါ",
    "strid10": "ကစားသမားကိုသတင်းပို့ပါ",
    "strid11": "အကြောင်းပြချက်အစီရင်ခံပါ",
    "strid12": "ရလဒ်ရလဒ်",
    "strid13": "လက်ခံသည်",
    "strid14": "ချိုးဖောက်မှု",
    "strid15": "ပြစ်ဒဏ်အချိန်",
    "strid16": "ပြစ်ဒဏ်အကြောင်းပြချက်",
    "strid17": "အချိန်ပိတ်ပင်",
    "strid18": "အယူခံ",
    "strid19": "အယူခံဝင်",
    "strid20": "အတည်ပြုသည်",
    "strid21": "အယူခံဝင်ခြင်းမအောင်မြင်ပါ",
    "strid22": "အယူခံရလဒ်",
    "strid23": "အယူခံဝင်အောင်မြင်သည်",
    "strid24": "ချက်ချင်း",
    "strid25": "အယူခံပုံစံ",
    "strid26": "ပြစ်ဒဏ်ဖြစ်နိုင်သောအကြောင်းပြချက်",
    "strid27": "ဗွီဒီယို / ရုပ်ပုံ / plug-in software download လိပ်စာ",
    "strid28": "ဖော်ပြချက်",
    "strid29": "Self- ဝန်ဆောင်မှုစနစ်",
    "strid30": "နာမည်ပြောင်များ",
    "strid31": "AccountID",
    "strid32": "အဆင့်",
    "strid33": "အဆင့်",
    "strid34": "ဂိမ်း၏ကြာချိန်",
    "strid35": "ဖုန်းမော်ဒယ်",
    "strid36": "စာတိုက်ပုံး",
    "strid37": "စည်းနှောင်ထားသော AccountID （google， fb or vk）",
    "strid38": "အယူခံဝင်ခြင်းမပြုမီသင်၏အကောင့်အချက်အလက်နှင့်ဆက်သွယ်ရန်အချက်အလက်များကိုဖြည့်သွင်းရန်သင့်အားဆက်သွယ်နိုင်မည်",
    "strid39": "ငါ့အကောင့်ခိုးသွားတယ်",
    "strid40": "ငါ့ရဲ့အကောင့်ကိုငါသာသုံးခဲ့တယ်။",
    "strid41": "ငါလိမ်တာငါဝန်ခံတယ်နောက်တဖန်ထိုသို့ပြုလိမ့်မည်မဟုတ်ပေ။",
    "strid42": "ကျေးဇူးပြု၍ ရိုက်ထည့်ပါ ",
    "strid43": "Customer Service ကိုဆက်သွယ်ပါ",
    "strid44": 'ငါသိတယ်',
    "strid45": 'မဟုတ်ဘူး',
    "strid46": 'ကျေးဇူးပြုပြီးပုံစံကိုဖြည့်ပါ',
  }
}

